const InspectionCheckData = [
  {
    check: false,
    ObsID: 0,
    Obs: 'Chock Wheels',
  },
  {
    check: false,
    ObsID: 1,
    Obs: 'Oil, Coolant, Auto Transmission Levels',
  },
  {
    check: false,
    ObsID: 2,
    Obs: 'P/W Steering, Steer Hub Oil Level',
  },
  {
    check: false,
    ObsID: 3,
    Obs: 'Belts, Fan, Pulleys, Tensioners',
  },
  {
    check: false,
    ObsID: 4,
    Obs: 'Air Filter, Air Filter Tubes and Pipes',
  },
  {
    check: false,
    ObsID: 5,
    Obs: 'Air Compressor Intake/Discharge Hoses/Lines',
  },
  {
    check: false,
    ObsID: 6,
    Obs: 'Air Compressor Signs of Heat and/or Oil',
  },
  {
    check: false,
    ObsID: 7,
    Obs: 'Air Dryer, Air Governor, Exhaust Port',
  },
  {
    check: false,
    ObsID: 8,
    Obs: 'Steering Box Mounts, Leaks, Secured',
  },
  {
    check: false,
    ObsID: 9,
    Obs: 'Park Brake Operation, Clutch Free Play',
  },
  {
    check: false,
    ObsID: 10,
    Obs: 'Oil, Coolant, Charging, Air Gauges',
  },
  {
    check: false,
    ObsID: 11,
    Obs: 'Windshield, Wipers, Mirrors',
  },
  {
    check: false,
    ObsID: 12,
    Obs: 'Horn, Defroster, Warning Devices',
  },
  {
    check: false,
    ObsID: 13,
    Obs: 'Triangle Box and Fire Extinguisher',
  },
  {
    check: false,
    ObsID: 14,
    Obs: 'All lights and Reflectors',
  },
  {
    check: false,
    ObsID: 15,
    Obs: 'Trailer Plug, Receptacle, Cord, 7-Way',
  },
  {
    check: false,
    ObsID: 16,
    Obs: 'Box/Bed Mounts, Roof/Skin, Mud Flaps',
  },
  {
    check: false,
    ObsID: 17,
    Obs: 'Tires - Depths within Spec and Condition',
  },
  {
    check: false,
    ObsID: 18,
    Obs: 'Rims, Lugs and Dual Mating',
  },
  {
    check: false,
    ObsID: 19,
    Obs: 'Radiator Condition, Hoses, Leaks',
  },
  {
    check: false,
    ObsID: 20,
    Obs: 'Engine and Transmission Mounts',
  },
  {
    check: false,
    ObsID: 21,
    Obs: 'King Pins, Steering Arm(s), Tie Rods',
  },
  {
    check: false,
    ObsID: 22,
    Obs: 'Exhaust System, Driveline, Carriers',
  },
  {
    check: false,
    ObsID: 23,
    Obs: 'U-Bolts, Welds, Cross Members',
  },
  {
    check: false,
    ObsID: 24,
    Obs: 'Hub Oil Levels, Wheel Seals',
  },
  {
    check: false,
    ObsID: 25,
    Obs: 'Fuel Tank Mounts, Caps, Hoses',
  },
  {
    check: false,
    ObsID: 26,
    Obs: 'General Engine and Drive Train Leaks',
  },
  {
    check: false,
    ObsID: 27,
    Obs: 'Wires and Hoses - Rubbing and/or Chaffing',
  },
  {
    check: false,
    ObsID: 28,
    Obs: 'Liftgate Operation and Condition',
  },
  {
    check: false,
    ObsID: 29,
    Obs: 'Battery(s) Condition, Connections',
  },
  {
    check: false,
    ObsID: 30,
    Obs: 'ABS Warning Light',
  },
  {
    check: false,
    ObsID: 31,
    Obs: 'Low Air Audible and/or Visual Alarm',
  },
  {
    check: false,
    ObsID: 32,
    Obs: 'Air Compressor Build-up Time',
  },
  {
    check: false,
    ObsID: 33,
    Obs: 'Air Dryer/Governor Purge Cycle',
  },
  {
    check: false,
    ObsID: 34,
    Obs: 'Air Loss-Supply Leakage - Unapplied',
  },
  {
    check: false,
    ObsID: 35,
    Obs: 'Air Loss-Service Leakage - Applied',
  },
  {
    check: false,
    ObsID: 36,
    Obs: 'Tractor Protection System',
  },
  {
    check: false,
    ObsID: 37,
    Obs: 'Air Tank(s) Mounts and Drained',
  },
  {
    check: false,
    ObsID: 38,
    Obs: 'Air Brake Lines/Hoses Secured',
  },
  {
    check: false,
    ObsID: 39,
    Obs: 'Air Brake Chambers Condition, Mounts',
  },
  {
    check: false,
    ObsID: 40,
    Obs: 'Air Slack Adjuster(s) Balance, 90° Angle',
  },
  {
    check: false,
    ObsID: 41,
    Obs: 'Air Slack Adjuster(s) Stroke within Spec',
  },
  {
    check: false,
    ObsID: 42,
    Obs: 'Drums and Rotor Condition',
  },
  {
    check: false,
    ObsID: 43,
    Obs: 'Brake Lining (Shoes/Pads) Condition',
  },
  {
    check: false,
    ObsID: 44,
    Obs: 'Overall Brake Adjustment',
  },
  {
    check: false,
    ObsID: 45,
    Obs: 'Fifth Wheel, Pintle Hook and Hitches',
  },
  {
    check: false,
    ObsID: 46,
    Obs: 'Set Park Brake',
  },
  {
    check: false,
    ObsID: 47,
    Obs: 'Remove Wheel Chocks (Optional)',
  },
];

export default InspectionCheckData;



// WEBPACK FOOTER //
// ./src/data/InspectionCheckData.js